import {Map} from '../../utils/immutable'
import {AuthState, AuthStateMap} from './types'

export const initialState: AuthStateMap = Map<AuthState>({
  isLoading: false,
  isLoggedIn: false,
  isInitialized: false,
  phoneLoginStep: null,
  phoneLoginLoading: false,
  phoneLoginError: null,
  confirmationResult: null,
  phoneIdToken: null,
})
